export const mobileImages = [
  `assets/common/Header_Background_Images/A32332_541_3_RGB_alt 1.jpg`,
  `assets/common/Header_Background_Images/GiftImage.jpg`,
  `assets/common/Header_Background_Images/mobile_bg1.jpg`,
  `assets/common/Header_Background_Images/mobile_bg2.jpg`,
  `assets/common/Header_Background_Images/mobile_bg3.jpg`,
  `assets/common/Header_Background_Images/mobile_bg4.jpg`,
  `assets/common/Header_Background_Images/mobile_bg5.jpg`,
  `assets/common/Header_Background_Images/PL00501381.jpg`,
  `assets/common/Header_Background_Images/PL00502034.jpg`,
  `assets/common/Header_Background_Images/PL00531841.jpg`,
  `assets/common/Header_Background_Images/PL00532423.jpg`,
  `assets/common/Header_Background_Images/PL00534029.jpg`,
  `assets/common/Header_Background_Images/PL00537533.jpg`,
  `assets/common/Header_Background_Images/PL00539007.jpg`,
  `assets/common/Header_Background_Images/PL00542964.jpg`,
  `assets/common/Header_Background_Images/PL00548445.jpg`,
  `assets/common/Header_Background_Images/PL00550649.jpg`,
  `assets/common/Header_Background_Images/PL00551469_alt.jpg`,
  `assets/common/Header_Background_Images/PL00551659.jpg`,
  `assets/common/Header_Background_Images/PL00551798_alt.jpg`,
  `assets/common/Header_Background_Images/PL00557134.jpg`,
  `assets/common/Header_Background_Images/PL00558512.jpg`,
  `assets/common/Header_Background_Images/PL00558922.jpg`,
  `assets/common/Header_Background_Images/PL00565608_BW.jpg`,
  `assets/common/Header_Background_Images/PL00569380_WORK.jpg`,
  `assets/common/Header_Background_Images/PL00569402_WORK.jpg`,
  `assets/common/Header_Background_Images/PL00574873.jpg`,
  `assets/common/Header_Background_Images/PL00635064.jpg`,
  `assets/common/Header_Background_Images/PL00651565.jpg`,
  `assets/common/Header_Background_Images/PL00651636_WORK.jpg`,
  `assets/common/Header_Background_Images/PL00651639-1.jpg`,
  `assets/common/Header_Background_Images/PL00658492_alt.jpg`,
  `assets/common/Header_Background_Images/PL00659296.jpg`,
  `assets/common/Header_Background_Images/PL00663023.jpg`,
  `assets/common/Header_Background_Images/PL00671553.jpg`,
  `assets/common/Header_Background_Images/PL00706621.jpg`,  
  ];

  export const desktopImages = [
    `assets/common/Header_Background_Images/desktop_bg1.jpg`,
    `assets/common/Header_Background_Images/desktop_bg2.jpg`,
    `assets/common/Header_Background_Images/desktop_bg3.jpg`,
    `assets/common/Header_Background_Images/desktop_bg4.jpg`,
    `assets/common/Header_Background_Images/desktop_bg5.jpg`,
  ];
